import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useAuth from "app/hooks/useAuth";
import axios from "axios";
import { useDispatch } from "react-redux";

const initialState = {
  listviewData: [],
  getOnboardingData: [],
  getOnboardingLoading: false,
  getOnboardingStatus: "idle",

  //=======GetIndustry======//
  getIndustryData: [],
  getIndustryLoading: false,
  getIndustryStatus: "idle",

  //myprofile/getsocials
  GetSocialsData: [],
  GetSocialsDataLoading: false,
  GetSocialsDataStatus: "idle",
  //=======MYPROFILE MENU========
  ProfileStatusSummaryGETData: {},
  ProfileStatusSummaryGETDataLoading: false,
  ProfileStatusSummaryGETDataStatus: "idle",
  //=======GetIndustryByUserID======//
  getIndustryByUserData: [],
  getIndustryByUserLoading: false,
  getIndustryByUserStatus: "idle",
  //=======GetSkill======//
  getSkillData: [],
  getSkillLoading: false,
  getSkillStatus: "idle",
  //CREATE Internships/GET Skills==========
  getSkillBycreteinternsStatus: "idle",
  getSkillBycreateinternsLoading: false,
  getSkillBycreteinternsData: [],

  //CREATEJob GetEducation
  CreateJobGetEducationStatus: "idle",
  CreateJobGetEducationLoading: false,
  CreateJobGetEducationData: [],

  //CreateJob GetIndustrySpecific
  CreateJobGetIndustryStatus: "idle",
  CreateJobGetIndustryLoading: false,
  CreateJobGetIndustryData: [],

  //MyProfile============GET_LANGUAGE====

  getLanguageByUserData: [],
  getSlanguageUserLoading: false,
  getanguageByUserStatus: "idle",

  //=======GetSkillByUser======//
  getSkillByUserData: [],
  getSkillByUserLoading: false,
  getSkillByUserStatus: "idle",
//===============Support/ Issue Type Dropdown===============//
 IssueTypeGetData : [],   
 IssueTypeGetLoading : false,
 IssueTypeGetStatus : "idle",
//===============Support/FAQ _GET==================//
 FaqGetData : [], 
 FaqGetLoading : false,  
 FaqGetStatus : "idle",
//=======JoinAS===/
  getJoinAsData: [],
  getJoinAsLoading: false,
  getJoinAsStatus: "idle",

  //========EMAILVERIFY===/
  getEmailVerifyData: {},
  getEmailVerifyLoading: false,
  getEmailVerifyStatus: "idle",

  //========getEducation===/
  getEducationData: [],
  getEducationLoading: false,
  getEducationStatus: "idle",
  //========getEducation===/
  getEducationByData: {},
  getEducationByLoading: false,
  getEducationByStatus: "idle",
  //========getExperience===/
  getExperienceData: [],
  getExperienceLoading: false,
  getExperienceStatus: "idle",
  //========getByExperience===/
  getExperienceByData: {},
  getExperienceByLoading: false,
  getExperienceByStatus: "idle",

  //========Get ScreenCaption Language===/
  ScreenCaptionData: {},
  ScreenCaptionLoading: false,
  ScreenCaptionStatus: "idle",

  //========getMyAccount===/
  getMyAccountData: {},
  getMyAccountLoading: false,
  getMyAccountStatus: "idle",
  getMyAccountSkillData: [],
  getHeadshotData: [],
  getMyAccountIndustryData: [],
  getExperienceUserData: [],
  getEducationUserData: [],
  getPhotosData: [],
  getVideosData: [],
  getArthographyData: [],
  getIntershipData: [],
  getApprenticeshipData: [],
  getMyAccountProjectData: [],
  getMyAccountSocialsData: [],
  //=============getUserLanguage==============
  getUserLanguageStatus: "idle",
  getUserLanguageLoading: false,
  getUserLanguageData: [],

  //=============getUserLanguage==============
  getLookingForStatus: "idle",
  getLookingForLoading: false,
  getLookingForData: [],

  //=============SavedPost/GETReport==============
  GETReportStatus: "idle",
  GETReportLoading: false,
  GETReportData: [],

  //================NETWORK/GetProjectComments==========
  GETnetworkProjectStatus: "idle",
  GETnetworkProjectLoading: false,
  GETnetworkProjectData: [],

  //================NETWORK/GetPOSTComments=============
  GETnetworkPostStatus: "idle",
  GETnetworkPostLoading: false,
  GETnetworkPostData: [],

 //================NETWORK/GetProjectLikes==========
  GETnetworkProjectLikesStatus: "idle",
  GETnetworkProjectLikesLoading: false,
  GETnetworkProjectLikesData: [],

  //================NETWORK/GetPostLikes=============
  GETnetworkPostLikesStatus: "idle",
  GETnetworkPostLikesLoading: false,
  GETnetworkPostLikesData: [],

  
  //=============CREATE/GETreachlimit===============
  GETreachlimitStatus: "idle",
  GETreachlimitLoading: false,
  GETreachlimitData: [],

  //=====GetUserDevice=======//
  getUserDeviceStatus: "idle",
  getUserDeviceLoading: false,
  getUserDeviceData: [],

  //=====GetOpportunities=======//
  getOpportunitiesStatus: "idle",
  getOpportunitiesLoading: false,
  getOpportunitiesData: [],
  getOpportunitiesProfile: "",
  //=====GetCollab=======//
  getCollabStatus: "idle",
  getCollabLoading: false,
  getCollabData: [],
  getSuggestedCollabData: [],
  getCreatorsCollabData: [],
  //=====GetNetwork=======//
  getNetworkStatus: "idle",
  getNetworkLoading: false,
  getNetworkData: [],
  //=====GETSEARCH===//
  getSearchStatus: "idle",
  getSearchLoading: false,
  getSearchAllData: [],
  getSearchGigData: [],
  getSearchProjectData: [],
  getSearchIntData: [],
  getSearchAptData: [],
  getSearchArtData: [],
  getSearchJobData: [],

  //=========GETSAVEDPOST===//
  getSavedPostStatus: "idle",
  getSavedPostLoading: false,
  getSavedPostAllData: [],
  getSavedPostGigData: [],
  getSavedPostProjectData: [],
  getSavedPostIntData: [],
  getSavedPostAptData: [],
  getSavedPostArtData: [],
  getSavedPostJobData: [],
  //========GetNotification====//
  getNotificationStatus: "idle",
  getNotificationLoading: false,
  getNotificationData: {},


  //===============Home/GetHomeNotification==================//
  homeNotificationStatus: "idle",
  homeNotificationLoading: false,
  homeNotificationData: [],

  //===========getBookMarkData=======//

  getBookMarkStatus: "idle",
  getBookMarkLoading: false,
  getBookMarkData: [],
  getBookMarkArtiztData: [],
  sortOrderAsc: true,
  //===========GetGigWorkById=======//

  getGigWorkByIdStatus: "idle",
  getGigWorkByIdLoading: false,
  getGigWorkByIdData: {},

  //===========GetApprenticeshipById=======//

  getApprenticeshipByIdStatus: "idle",
  getApprenticeshipByIdLoading: false,
  getApprenticeshipByIdData: {},
  //===========GetGigWorkById=======//

  getInternshipByIdStatus: "idle",
  getInternshipByIdLoading: false,
  getInternshipByIdData: {},

  //============GetSimilarJobs=========//

  GetSimilarJobsStatus: "idle",
  GetSimilarJobsLoading: false,
  GetSimilarJobsData: [],

  //===============GetInterview===========//
  GetInterviewStatus: "idle",
  GetInterviewLoading: false,
  GetInterviewData: [],
  //===========GetProjectById=======//

  getProjectByIdStatus: "idle",
  getProjectByIdLoading: false,
  getProjectByIdData: {},
  //==============GETBLOCKEDUSER=========//
  getBlockedUserStatus: "idle",
  getBlockedUserLoading: false,
  getBlockedUserData: [],
  //====================GETHIRED JOB CREATOR DASHBOARD=====//
  getHiredStatus: "idle",
  getHiredLoading: false,
  getHiredAllData: [],
  getHiredGigData: [],
  getHiredJobsData: [],
  getHiredIntData: [],
  getHiredAptData: [],
  getHiredStoppedData: [],
  getHiredDraftData: [],
  getHiredClosedData: [],
  getHiredPausedData: [],

  //=========================================/Hiring Dashboard==================//
  getdasboardStatus: "idle",
  getdasboardLoading: false,
  gtDashboardData: [],
  //====================GETAPPLIED=====//
  getAppliedStatus: "idle",
  getAppliedLoading: false,
  getAppliedAllData: [],
  getAppliedGigData: [],
  getAppliedProjectData: [],
  getAppliedIntData: [],
  getAppliedAptData: [],
  getAppliedArtData: [],
  //====================GetAppliedArtist============/
  getAppliedArtistStatus: "idle",
  getAppliedArtistLoading: false,
  getAppliedArtistData: [],

  //=======================PersonalChatList===============//
  getPersonalChatListStatus: "idle",
  getPersonalChatListLoading: false,
  getPersonalChatListData: [],
  //==================PersonalChatMessage==========================//
  getPersonalChatMessageStatus: "idle",
  getPersonalChatMessageLoading: false,
  getPersonalChatMessageData: [],
  ///==================GroupChatGet====================//
  getGroupChatStatus: "idle",
  getGroupChatLoading: false,
  getGroupChatData: [],
  //=====================GroupChatMessage======================//
  getGroupChatMessageStatus: "idle",
  getGroupChatMessageLoading: false,
  getGroupChatMessageData: [],
  //=====================GroupChatMessage======================//
  getGroupStatus: "idle",
  getGroupLoading: false,
  getGroupData: {},
  //========GroupMember=============//
  getGroupMemberStatus: "idle",
  getGroupMemberLoading: false,
  getGroupMemberData: [],

  //=======GETPROJECTTYPE==//
  getProjectTypeData: [],
  getProjectTypeStatus: "idle",
  getProjectTypeLoading: false,

  //=======GETROLES==//
  getRolesData: [],
  getRolesStatus: "idle",
  getRolesLoading: false,

  //===========GETCOLLAABORATOR===============
  getCollaboratorStatus: "idle",
  getCollaboratorLoading: false,
  getCollaboratorData: [],

  //===========GETCOLLAABORATOR===============
  getProjectListStatus: "idle",
  getProjectListLoading: false,
  getProjectListData: [],
  //==================================//
  getGetProjectStatus: "idle",
  getGetProjectLoading: false,
  getGetProjectData: [],
  getGetProjectCollabData: [],
  getGetProjectEndoresementData: [],

  //===========GETCOLLAABORATOR===============
  getUnionAssociationStatus: "idle",
  getUnionAssociationLoading: false,
  getUnionAssociationData: [],
  //CREATE Jobs/GET Benefits==========
  getbenefitsStatus: "idle",
  getbenefitsLoading: false,
  getbenefitsData: [],

  //==============GET TOOLS/SOFTWARE=======
  gettoolsSoftwareStatus: "idle",
  gettoolsSoftwareLoading: false,
  gettoolsSoftwareData: [],

  //===========getJobIdStatus=======//

  getJobIDStatus: "idle",
  getJobIDLoading: false,
  getJobIDData: {},

  //========GetDashBoardData============//
  getDashboardStatus: "idle",
  getDashboardLoading: false,
  getDashboardData: {},
getDashboardUIData : [],

//=============MYPROFILE / GetFollowingUsers//
getFollowUsersStatus: "idle",
getFollowUsersLoading: false,
getFollowUsersData : [],
  //========ApplicationHistory============//
  getApplicationHistoryStatus: "idle",
  getApplicationHistoryLoading: false,
  getApplicationHistoryData: [],
  getApperror: null,



//======APPLIEDUSERDETAILS=====//
  getAppliedUserStatus: "idle",
  getAppliedUserDetailsLoading: false,
  getAppliedUserCreaData: [],
  getAppliedUserApplicantsData:[],

//======APPLIEDUSERDETAILS=====//
  getNotesStatus: "idle",
  getNotesLoading: false,
  getNotesData: [],
//===========PlanGet==========/
getPlanGetData: [], 
  getPlanGetLoading: false,
  getPlanGetStatus: "idle",
//==================GetSubscriptionDetails//
  getSubscriptionDetailsData: [],
  getSubscriptionDetailsLoading: false,
  getSubscriptionDetailsStatus: "idle",
  getSubscriptionDetailsBillingData:[],
  
  error: null,
  postImageData: {},
};

export const GetOnboarding = createAsyncThunk(
  "page/GetOnboarding",
  async (_, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Onboarding/GetOnboarding`;
      const response = await axios.get(URL, {
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
// export const GetIndustry = createAsyncThunk(
//   "page/GetIndustry",
//   async (_, { rejectWithValue }) => {
//     try {
//             const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetIndustry`

//       // const URL = `${process.env.REACT_APP_BASE_URL}Registration/Industry`
//       const response = await axios.get(URL, {
//         headers: {
//           Authorization: `${process.env.REACT_APP_API_TOKEN}`
//         },

//       });
//       console.log(response.data);
//       return response.data;

//     } catch (error) {
//       // Handle errors, including network or authorization issues
//       return rejectWithValue(error.response ? error.response.data : error.message);
//     }
//   }
// );

export const GetIndustry = createAsyncThunk(
  "page/GetIndustry",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetIndustry`;

      // const URL = `${process.env.REACT_APP_BASE_URL}Registration/Industry`
      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//SOCIALS_GET_COMPLETE PROFILE
export const GetSocials = createAsyncThunk(
  "Myprofile/GetSocials",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const URL = `${process.env.REACT_APP_BASE_URL}Profile/GetSocials`;

      // const URL = `${process.env.REACT_APP_BASE_URL}Registration/Industry`
      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,

        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//Profile/ProfileStatusSummary
export const ProfileStatusSummaryGET = createAsyncThunk(
  "Myprofile/Complete profile menu",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const URL = `${process.env.REACT_APP_BASE_URL}Profile/ProfileStatusSummary`;

      // const URL = `${process.env.REACT_APP_BASE_URL}Registration/Industry`
      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,

        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const GetIndustryByUserID = createAsyncThunk(
  "page/GetIndustryByUserID",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };

      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetUserIndustry`;
      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ===================GET HIRED SINGLE SELECT AND MULTISELECT SKILLS GET==================
// export const GetSkills = createAsyncThunk(
//   "page/GetSkills",
//   async ({ ID, UserID }, { rejectWithValue }) => {
//     try {
//       const params = {
//         data: JSON.stringify({ IndustryID: ID, UserID }),
//       };

//       const URL = `${process.env.REACT_APP_BASE_URL}Registration/Skill`;

//       const response = await axios.get(URL, {
//         params,
//         headers: {
//           Authorization: `${process.env.REACT_APP_API_TOKEN}`,
//         },
//       });

//       console.log(response.data);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response ? error.response.data : error.message);
//     }
//   }
// );

// ===================GET HIRED SINGLE SELECT AND MULTISELECT SKILLS GET==================

export const GetSkill = createAsyncThunk(
  "page/GetSkill",
  async ({ IndustryID, UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ IndustryID, UserID }),
      };

      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/Skill`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ===================Create Internships_EditScreen Skills Get==================
export const CreateIntersGetSkill = createAsyncThunk(
  "CreateInternship/GetAllSkills",
  async (_, { rejectWithValue }) => {
    try {
      // const params = {
      //   data: JSON.stringify({ IndustryID: IndustryID }),
      // };

      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetAllSkills`;

      const response = await axios.get(URL, {
        // params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ===================CONTACTSUPPORT IssueType Chip_GET==================
export const IssueType = createAsyncThunk(
  "Support/IssueType",
  async (_, { rejectWithValue }) => {
    try {
           const token = sessionStorage.getItem("authToken");


      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetIssueType`;

      const response = await axios.get(URL, {
        // params,
        headers: {
          Authorization: `Bearer ${token}`,

          // Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ===================CONTACTSUPPORT FAQ_GET==================
export const FaqGet = createAsyncThunk(
  "ContactSupport/FaqGet",
  async (_, { rejectWithValue }) => {
    try {
           const token = sessionStorage.getItem("authToken");


      const URL = `${process.env.REACT_APP_BASE_URL}ContactSupport/GetFaqList`;

      const response = await axios.get(URL, {
        // params,
        headers: {
          Authorization: `Bearer ${token}`,

          // Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ===================Create Job GetEducation==================
export const CreateJobGetEducation = createAsyncThunk(
  "GetEducation/CreateJob",
  async (_, { rejectWithValue }) => {
    try {
      // const params = {
      //   data: JSON.stringify({ IndustryID: IndustryID }),
      // };
      const token = sessionStorage.getItem("authToken");

      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetGeneralEducation`;

      const response = await axios.get(URL, {
        // params,
        headers: {
          Authorization: `Bearer ${token}`,

          // Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ===================Create Job GetIndustrySpecific==================
export const CreateJobGetIndustrySpecific = createAsyncThunk(
  "GetIndustrySpecific/CreateJob",
  async (_, { rejectWithValue }) => {
    try {
      // const params = {
      //   data: JSON.stringify({ IndustryID: IndustryID }),
      // };
      const token = sessionStorage.getItem("authToken");

      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetIndustrySpecific`;

      const response = await axios.get(URL, {
        // params,
        headers: {
          Authorization: `Bearer ${token}`,

          // Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const GetUserSkillByUserID = createAsyncThunk(
  "page/GetUserSkillByUserID",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetUserSkill`;
      // const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/GetUserSkill`
      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==============MY PROFILE/ Basic Info/ Language_GET==================
export const BasicInfoLangGet = createAsyncThunk(
  "My Profile/BasicInfoLangGet",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetLanguages`;
      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const GetEmailVerify = createAsyncThunk(
  "page/GetEmailVerify",
  async ({ emailId, otp }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ emailId, otp }),
      };

      const URL = `${process.env.REACT_APP_BASE_URL}Registration/EmailVerification`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const GetJoinAs = createAsyncThunk(
  "page/GetJoinAs",
  async (_, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Registration/JoinAs`;
      const response = await axios.get(URL, {
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//=====================================GetExperience=================================================//
// export const GetExperience = createAsyncThunk(
//   "page/GetExperience",
//   async ({ UserID }, { rejectWithValue }) => {
//     try {
//       const params = {
//         data: JSON.stringify({ UserID }),
//       };

//       const URL = `${process.env.REACT_APP_BASE_URL}Registration/GetExperience`;

//       const response = await axios.get(URL, {
//         params,
//         headers: {
//           Authorization: `${process.env.REACT_APP_API_TOKEN}`,
//         },
//       });

//       console.log(response.data);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response ? error.response.data : error.message);
//     }
//   }
// );

//=====================================GetEducation=================================================//
export const GetEducation = createAsyncThunk(
  "page/GetEducation",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };

      //  const URL = `${process.env.REACT_APP_BASE_URL}Registration/GetEducation`;
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/GetEducation`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================================GetMyAccount=================================================//
export const GetMyAccount = createAsyncThunk(
  "page/GetMyAccount",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const token = sessionStorage.getItem("authToken");
      const URL = `${process.env.REACT_APP_BASE_URL}MyAccount/GetMyAccount`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================================GetUserLanguage=================================================//
export const GetUserLanguage = createAsyncThunk(
  "page/GetUserLanguage",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}MyAccount/GetUserLanguage`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================================GetByEducation=================================================//
export const GetByEducation = createAsyncThunk(
  "page/GetByEducation",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Registration/GetByEducation`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================================GetByExperience=================================================//
export const GetByExperience = createAsyncThunk(
  "page/GetByExperience",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Registration/GetByExperience`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================================ScreenCaption I18next========================
export const ScreenCaption = createAsyncThunk(
  "Language/ScreenCaption",
  async ({ Language }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ Language }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `https://api.creanetwork.in/api/ScreenCaption`;

      const response = await axios.get(URL, {
        params,
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiYWRtaW4iOnRydWUsImlhdCI6MTUxNjIzOTAyMn0.KMUFsIDTnFmyG3nMiGM6H9FNFUROf3wh7SmqJp-QV30`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================================GetLookingFor=================================================//
export const GetLookingFor = createAsyncThunk(
  "page/GetLookingFor",
  async (_, { rejectWithValue }) => {
    try {
      // const params = {
      //   data: JSON.stringify({UserID}),
      // };
      //  const token = sessionStorage.getItem("authToken");

      // console.log("user.Token;",token);
      const URL = `${process.env.REACT_APP_BASE_URL}Registration/GetLookingFor`;

      const response = await axios.get(URL, {
        // params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================================SavedPOST/GETREPORT=================================================//
export const GETReport = createAsyncThunk(
  "SavedPOST/GETReport",
  async (_, { rejectWithValue }) => {
    try {
      // const params = {
      //   data: JSON.stringify({UserID}),
      // };
       const token = sessionStorage.getItem("authToken");

      console.log("user.Token;",token);
      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetReportReason`;

      const response = await axios.get(URL, {
        // params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//====================================HOME/NETWORK/GetProjectComments==========================
export const GetProjectComments = createAsyncThunk(
  "Network/GetProjectComments",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Project/GetProjectComments`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


//====================================HOME/NETWORK/GetProjectLikes==========================
export const GetProjectLikes = createAsyncThunk(
  "Network/GetProjectLikes",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Project/GetProjectLikes`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


//====================================HOME/NETWORK/GetPostLikes==========================
export const GetPostLikes = createAsyncThunk(
  "Network/GetPostLikes",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Post/GetPostLikes`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


//====================================CREATE/WarningGET for react limit==========================
export const GETreachlimit = createAsyncThunk(
  "CREATE/GETreachlimit",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Home/GetUserUsageStats`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//====================================HOME/NETWORK/POSTCOmments/GET==========================
export const GetPOSTComments = createAsyncThunk(
  "Network/GetPOSTComments",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Post/GetPostComments`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//=====================================GetUserDevice=================================================//
export const GetUserDevice = createAsyncThunk(
  "page/GetUserDevice",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Settings/GetUserDevice`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//=====================================GetOpportunities=================================================//
export const GetOpportunities = createAsyncThunk(
  "page/GetOpportunities",
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Home/GetOpportunities`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//=====================================GetCollab=================================================//
export const GetCollab = createAsyncThunk(
  "page/GetCollab",
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Home/GetCollab`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//=====================================GetNetwork=================================================//
export const GetNetwork = createAsyncThunk(
  "page/GetNetwork",
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Home/GetNetwork`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================================GetSavedPosts=================================================//
export const GetSavedPosts = createAsyncThunk(
  "Posts/GetSavedPosts",
  async ({ UserID, Type }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Search/GetBookMark`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================================GetSearch=================================================//
export const GetSearch = createAsyncThunk(
  "page/GetSearch",
  async ({ Type }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Search/GetSearch`;
      // const URL = `https://uatapi.creanetwork.in/api/Search/GetSearch`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
          //           Authorization: `
          // Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3VhdGFwaS5jcmVhbmV0d29yay5pbi9hcGkvTG9naW4vTG9naW4iLCJpYXQiOjE3NTU3NDkxMjUsImV4cCI6MTc1NTgzNTUyNSwibmJmIjoxNzU1NzQ5MTI1LCJqdGkiOiJmNWppa056VXhpb2FZcDkyIiwic3ViIjoiMzg5IiwicHJ2IjoiODMwODQ5NjUwZjEwNzc4NzFmMjk1MGJjZGUyMzQzMGI0MTU5ZTc4ZCIsIm5hbWUiOiJTaWp1dSIsImVtYWlsIjoic2h5YW1yb2hhbjExNUBnbWFpbC5jb20iLCJSZWNvcmRJRCI6Mzg5fQ.lswcK2o02Arq3POr8aMzamFzwaj-wCg5s4kxlpBNIa8`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//=====================================Settings / GetNotification=================================================//
export const GetNotification = createAsyncThunk(
  "page/GetNotification",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Settings/GetNotification`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================================Home / GetHomeNotification=================================================//
export const GetHomeNotification = createAsyncThunk(
  "page/GetHomeNotification",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Notification/GetNotification`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================ApplyController/GetBookMark=====================//
export const GetBookMark = createAsyncThunk(
  "page/GetBookMark",
  async ({ UserID, Type }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}ApplyController/GetBookMark`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GetGigWorkById=====================//
export const GetGigWorkById = createAsyncThunk(
  "page/GetGigWorkById",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GigWork/GetGigWorkByID`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GetSimilarJobs=====================//
export const GetSimilarJobs = createAsyncThunk(
  "page/GetSimilarJobs",
  async ({ Type, RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ Type, RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Apply/GetSimilarJobs`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GetInterview=====================//
export const GetInterview = createAsyncThunk(
  "page/GetInterview",
  async ({ AppliedID, Type }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ AppliedID, Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/GetInterview`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GetApprenticeshipById=====================//
export const GetApprenticeshipById = createAsyncThunk(
  "page/GetApprenticeshipById",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Apprenticeship/GetApprenticeshipByID`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GetInternshipById=====================//
export const GetInternshipById = createAsyncThunk(
  "page/GetInternshipById",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      //Internship/GetInternshipByID
      const URL = `${process.env.REACT_APP_BASE_URL}Internship/GetInternshipByID`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GetProjectById=====================//
export const GetProjectById = createAsyncThunk(
  "page/GetProjectById",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Project/GetProjectById`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GetProjectById=====================//
export const GetBlockedUser = createAsyncThunk(
  "page/GetBlockedUser",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Profile/GetBlockedUser`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GetHired=====================//
export const GetHired = createAsyncThunk(
  "page/GetHired",
  async ({ UserID, Type }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/GetUserOpportunity`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GetHireing Dashboard=====================//
export const GetHireddashboard = createAsyncThunk(
  "page/GetHireddashboard",
  async ({ UserID,FromDate,ToDate,Type,Year,FromMonth,ToMonth }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID ,FromDate,ToDate,Type,Year,FromMonth,ToMonth}),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/GetHiringChatData`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GetApplied=====================//
export const GetApplied = createAsyncThunk(
  "page/GetApplied",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Applied/GetApplied`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GetAppliedArtist=====================//
export const GetAppliedArtist = createAsyncThunk(
  "page/GetAppliedArtist",
  async ({ RecordID, Type, Status }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID, Type, Status }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Applied/GetAppliedArtist`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================PersonalChatList=====================//
export const PersonalChatList = createAsyncThunk(
  "page/PersonalChatList",
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}PersonalChat/PersonalChatList`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//=====================================PersonalChat/PersonalChatMessage==============================/
export const PersonalChatMessage = createAsyncThunk(
  "page/PersonalChatMessage",
  async ({ SenderID, ReceiverID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ SenderID, ReceiverID }),
      };
      const token = sessionStorage.getItem("authToken");
      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}PersonalChat/PersonalChatMessage`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//=====================================GroupChat/GroupChatMessage==============================/
export const GroupChatGet = createAsyncThunk(
  "page/GroupChatGet",
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/GroupChatGet`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==============================GroupChat/GroupChatMessage=========================//
export const GroupChatMessage = createAsyncThunk(
  "page/GroupChatMessage",
  async ({ UserID, GroupID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, GroupID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/GroupChatMessages`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==========================GroupChat/GroupChatGetBYID=================//
export const GroupChatGetBYID = createAsyncThunk(
  "page/GroupChatGetBYID",
  async ({ UserID, GroupID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, GroupID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/GroupChatGetByID`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GroupChat/GroupMember=======================//
export const GroupMember = createAsyncThunk(
  "page/GroupMember",
  async ({ UserID, GroupID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, GroupID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/GroupMembers`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GroupChat/GroupMember=======================//
export const GetProjectType = createAsyncThunk(
  "page/GetProjectType",
  async ({ UserID }, { rejectWithValue }) => {
    const params = {
      data: JSON.stringify({ UserID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetProjectType`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GroupChat/GroupMember=======================//
export const GetRoles = createAsyncThunk(
  "page/GetRoles",
  async ({ Type }, { rejectWithValue }) => {
    const params = {
      data: JSON.stringify({ Type }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetRoles`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GroupChat/GroupMember=======================//
export const GetCollaborator = createAsyncThunk(
  "page/GetCollaborator",
  async ({ ProjectID }, { rejectWithValue }) => {
    const params = {
      data: JSON.stringify({ ProjectID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Project/GetCollaborator`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GroupChat/GroupMember=======================//
export const ProjectList = createAsyncThunk(
  "page/ProjectList",
  async ({ UserID }, { rejectWithValue }) => {
    const params = {
      data: JSON.stringify({ UserID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Project/ProjectList`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GroupChat/GroupMember=======================//
export const GetProject = createAsyncThunk(
  "page/GetProject",
  async ({ RecordID }, { rejectWithValue }) => {
    const params = {
      data: JSON.stringify({ RecordID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Project/GetProject`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GroupChat/GroupMember=======================//
export const GetExperience = createAsyncThunk(
  "page/GetExperience",
  async ({ UserID }, { rejectWithValue }) => {
    const params = {
      data: JSON.stringify({ UserID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/GetExperience`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================UserProfile/GetUnionAssociation=======================//
export const GetUnionAssociation = createAsyncThunk(
  "page/GetUnionAssociation",
  async ({ UserID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID }),
      };

      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/GetUnionAssociation`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ===================Create JOB_EditScreen CRETAE_JOB Get==================

export const CreateJobGetBenefits = createAsyncThunk(
  "CreateJob/GetBenefits",
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetBenefits`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==========================CRETE JOB ==TOOLS / SOFTWARE==========
export const toolsSoftwareGet = createAsyncThunk(
  "Create/Toolssoftware",
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Dropdown/GetTools`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GetInternshipById=====================//
export const GetJobByID = createAsyncThunk(
  "page/GetJobByID",
  async ({ RecordID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      //Internship/GetInternshipByID
      const URL = `${process.env.REACT_APP_BASE_URL}Jobs/JobGetByID`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GetDashboardData=====================//
export const GetDashboardData = createAsyncThunk(
  "page/GetDashboardData",
  async ({ UserID, FromDate, ToDate }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, FromDate, ToDate }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      //Internship/GetInternshipByID
      const URL = `${process.env.REACT_APP_BASE_URL}Applied/GetDashboardData`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================MYPROFILE / FollowersFolowing GET API=====================//
export const GetFollowingUsers = createAsyncThunk(
  "MYPROFILE/GetFollowingUsers",
  async ({ UserID, Type}, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}MyAccount/GetFollowingUsers`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================ApplicationHistoryGet=====================//
export const ApplicationHistoryGet = createAsyncThunk(
  "page/ApplicationHistoryGet",
  async ({ UserID, Type }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      //Internship/GetInternshipByID
      const URL = `${process.env.REACT_APP_BASE_URL}Applied/ApplicationHistoryGet`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==================================GetAppliedUser=====================//
export const GetAppliedUser = createAsyncThunk(
  "page/GetAppliedUser",
  async ({ RecordID,Type }, { rejectWithValueType }) => {
    try {
      const params = {
        data: JSON.stringify({ RecordID,Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      //Internship/GetInternshipByID
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/GetAppliedUser`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return  rejectWithValueType(error.response ? error.response.data : error.message);
    }
  }
);

//==================================GetAppliedUser=====================//
export const GetNotes = createAsyncThunk(
  "page/GetNotes",
  async ({ AppliedID,Type }, { rejectWithValueType }) => {
    try {
      const params = {
        data: JSON.stringify({ AppliedID,Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      //Internship/GetInternshipByID
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/GetNotes`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return  rejectWithValueType(error.response ? error.response.data : error.message);
    }
  }
);



































//==================================GetAppliedUser=====================//
export const PlanGet = createAsyncThunk(
  "page/PlanGet",
  async ({Type }, { rejectWithValueType }) => {
    try {
      const params = {
        data: JSON.stringify({Type }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      //Internship/GetInternshipByID
      const URL = `${process.env.REACT_APP_BASE_URL}Subscription/PlanGet`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return  rejectWithValueType(error.response ? error.response.data : error.message);
    }
  }
);

//==================================GetAppliedUser=====================//
export const GetSubscriptionDetails = createAsyncThunk(
  "page/GetSubscriptionDetails",
  async ({UserID }, { rejectWithValueType }) => {
    try {
      const params = {
        data: JSON.stringify({UserID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      //Internship/GetInternshipByID
      const URL = `${process.env.REACT_APP_BASE_URL}Subscription/GetSubscriptionDetails`;

      const response = await axios.get(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return  rejectWithValueType(error.response ? error.response.data : error.message);
    }
  }
);



const getSlice = createSlice({
  name: "getSlice",
  initialState,
  reducers: {},
  //sortby field in savedPOST
  reducers: {
    sortBookMarkArtizts(state) {
      const sorted = [...state.getBookMarkArtiztData].sort((a, b) => {
        const nameA = (a.UserName || "").toLowerCase();
        const nameB = (b.UserName || "").toLowerCase();
        return state.sortOrderAsc
          ? nameA.localeCompare(nameB)
          : nameB.localeCompare(nameA);
      });
      console.log(sorted);

      state.getBookMarkArtiztData = sorted;
      state.sortOrderAsc = !state.sortOrderAsc;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(GetOnboarding.pending, (state) => {
        state.getOnboardingStatus = "loading";
        state.getOnboardingLoading = true;
        state.getOnboardingData = [];
      })
      .addCase(GetOnboarding.fulfilled, (state, action) => {
        state.getOnboardingStatus = "succeeded";
        state.getOnboardingLoading = false;
        state.getOnboardingData = action.payload.Data;
      })
      .addCase(GetOnboarding.rejected, (state, action) => {
        state.getOnboardingStatus = "failed";
        state.getOnboardingLoading = false;
        state.error = action.error.message;
        state.getOnboardingData = [];
      })
      //================GetIndustry============================//
      .addCase(GetIndustry.pending, (state) => {
        state.getIndustryStatus = "loading";
        state.getIndustryLoading = true;
        state.getIndustryData = [];
      })
      .addCase(GetIndustry.fulfilled, (state, action) => {
        state.getIndustryStatus = "succeeded";
        state.getIndustryLoading = false;
        state.getIndustryData = action.payload.Data;
      })
      .addCase(GetIndustry.rejected, (state, action) => {
        state.getIndustryStatus = "failed";
        state.getIndustryLoading = false;
        state.error = action.error.message;
        state.getIndustryData = [];
      })

      //===============Myprofile/getsocilas============================//
    
   .addCase(GetSocials.pending, (state) => {
        state.GetSocialsDataStatus = "loading";
        state.GetSocialsDataLoading = true;
        state.GetSocialsData = [];
      })
      .addCase(GetSocials.fulfilled, (state, action) => {
        state.GetSocialsDataStatus = "succeeded";
        state.GetSocialsDataLoading = false;
        state.GetSocialsData = action.payload.Data;
      })
      .addCase(GetSocials.rejected, (state, action) => {
        state.GetSocialsDataStatus = "failed";
        state.GetSocialsDataLoading = false;
        state.error = action.error.message;
        state.GetSocialsData = [];
      })

       //==============================MYPROFILE_COMPLETEPROFILE/MENU SECTION===========//


    .addCase(ProfileStatusSummaryGET.pending, (state) => {
        state.ProfileStatusSummaryGETDataStatus = "loading";
        state.ProfileStatusSummaryGETDataLoading = true;
        state.ProfileStatusSummaryGETData = {};
      })
      .addCase(ProfileStatusSummaryGET.fulfilled, (state, action) => {
        state.ProfileStatusSummaryGETDataStatus = "succeeded";
        state.ProfileStatusSummaryGETDataLoading = false;
        state.ProfileStatusSummaryGETData = action.payload.Data;
      })
      .addCase(ProfileStatusSummaryGET.rejected, (state, action) => {
        state.ProfileStatusSummaryGETDataStatus = "failed";
        state.ProfileStatusSummaryGETDataLoading = false;
        state.error = action.error.message;
        state.ProfileStatusSummaryGETData = {};
      })
      //================GetIndustryByUserID============================//
      .addCase(GetIndustryByUserID.pending, (state) => {
        state.getIndustryByUserStatus = "loading";
        state.getIndustryByUserLoading = true;
        state.getIndustryByUserData = [];
      })
      .addCase(GetIndustryByUserID.fulfilled, (state, action) => {
        state.getIndustryByUserStatus = "succeeded";
        state.getIndustryByUserLoading = false;
        state.getIndustryByUserData = action.payload.Data;
      })
      .addCase(GetIndustryByUserID.rejected, (state, action) => {
        state.getIndustryByUserStatus = "failed";
        state.getIndustryByUserLoading = false;
        state.error = action.error.message;
        state.getIndustryByUserData = [];
      })

      .addCase(GetSkill.pending, (state) => {
        state.getSkillStatus = "loading";
        state.getSkillLoading = true;
        state.getSkillData = [];
      })
      .addCase(GetSkill.fulfilled, (state, action) => {
        state.getSkillStatus = "succeeded";
        state.getSkillLoading = false;
        state.getSkillData = action.payload.Data;
      })
      .addCase(GetSkill.rejected, (state, action) => {
        state.getSkillStatus = "failed";
        state.getSkillLoading = false;
        state.error = action.error.message;
        state.getSkillData = [];
      })

      //================MyProfile/Basic Info Language_GET============================//
      .addCase(BasicInfoLangGet.pending, (state) => {
        state.getanguageByUserStatus = "loading";
        state.getSlanguageUserLoading = true;
        state.getLanguageByUserData = [];
      })
      .addCase(BasicInfoLangGet.fulfilled, (state, action) => {
        state.getanguageByUserStatus = "succeeded";
        state.getSlanguageUserLoading = false;
        state.getLanguageByUserData = action.payload.Data;
      })
      .addCase(BasicInfoLangGet.rejected, (state, action) => {
        state.getanguageByUserStatus = "failed";
        state.getSlanguageUserLoading = false;
        state.error = action.error.message;
        state.getLanguageByUserData = [];
      })

      //================GetUserSkillByUserID============================//
      .addCase(GetUserSkillByUserID.pending, (state) => {
        state.getSkillByUserStatus = "loading";
        state.getSkillByUserLoading = true;
        state.getSkillByUserData = [];
      })
      .addCase(GetUserSkillByUserID.fulfilled, (state, action) => {
        state.getSkillByUserStatus = "succeeded";
        state.getSkillByUserLoading = false;
        state.getSkillByUserData = action.payload.Data;
      })
      .addCase(GetUserSkillByUserID.rejected, (state, action) => {
        state.getSkillByUserStatus = "failed";
        state.getSkillByUserLoading = false;
        state.error = action.error.message;
        state.getIndustryByUserData = [];
      })

//===============Support/ Issue Type Dropdown===============//

      .addCase(IssueType.pending, (state) => {
        state.IssueTypeGetStatus = "loading";
        state.IssueTypeGetLoading = true;
        state.IssueTypeGetData = [];
      })
      .addCase(IssueType.fulfilled, (state, action) => {
        state.IssueTypeGetStatus = "succeeded";
        state.IssueTypeGetLoading = false;
        state.IssueTypeGetData = action.payload.Data;
      })
      .addCase(IssueType.rejected, (state, action) => {
        state.IssueTypeGetStatus = "failed";
        state.IssueTypeGetLoading = false;
        state.error = action.error.message;
        state.IssueTypeGetData = [];
      })

      //ContactSupport FAQ GET================
      
       .addCase(FaqGet.pending, (state) => {
        state.FaqGetStatus = "loading";
        state.FaqGetLoading = true;
        state.FaqGetData = [];
      })
      .addCase(FaqGet.fulfilled, (state, action) => {
        state.FaqGetStatus = "succeeded";
        state.FaqGetLoading = false;
        state.FaqGetData = action.payload.Data;
      })
      .addCase(FaqGet.rejected, (state, action) => {
        state.FaqGetStatus = "failed";
        state.FaqGetLoading = false;
        state.error = action.error.message;
        state.FaqGetData = [];
      })
      //CREATE_ INTERNSHIPS_GETSKILLS=============

      .addCase(CreateIntersGetSkill.pending, (state) => {
        state.getSkillBycreteinternsStatus = "loading";
        state.getSkillBycreateinternsLoading = true;
        state.getSkillBycreteinternsData = [];
      })
      .addCase(CreateIntersGetSkill.fulfilled, (state, action) => {
        state.getSkillBycreteinternsStatus = "succeeded";
        state.getSkillBycreateinternsLoading = false;
        state.getSkillBycreteinternsData = action.payload.Data;
      })
      .addCase(CreateIntersGetSkill.rejected, (state, action) => {
        state.getSkillBycreteinternsStatus = "failed";
        state.getSkillBycreateinternsLoading = false;
        state.error = action.error.message;
        state.getSkillBycreteinternsData = [];
      })
      //CreateJobGetEducation
      .addCase(CreateJobGetEducation.pending, (state) => {
        state.CreateJobGetEducationStatus = "loading";
        state.CreateJobGetEducationLoading = true;
        state.CreateJobGetEducationData = [];
      })
      .addCase(CreateJobGetEducation.fulfilled, (state, action) => {
        state.CreateJobGetEducationStatus = "succeeded";
        state.CreateJobGetEducationLoading = false;
        state.CreateJobGetEducationData = action.payload.Data;
      })
      .addCase(CreateJobGetEducation.rejected, (state, action) => {
        state.CreateJobGetEducationStatus = "failed";
        state.CreateJobGetEducationLoading = false;
        state.error = action.error.message;
        state.CreateJobGetEducationData = [];
      })
      //CreateJob GetIndustrySpecific

      .addCase(CreateJobGetIndustrySpecific.pending, (state) => {
        state.CreateJobGetIndustryStatus = "loading";
        state.CreateJobGetIndustryLoading = true;
        state.CreateJobGetIndustryData = [];
      })
      .addCase(CreateJobGetIndustrySpecific.fulfilled, (state, action) => {
        state.CreateJobGetIndustryStatus = "succeeded";
        state.CreateJobGetIndustryLoading = false;
        state.CreateJobGetIndustryData = action.payload.Data;
      })
      .addCase(CreateJobGetIndustrySpecific.rejected, (state, action) => {
        state.CreateJobGetIndustryStatus = "failed";
        state.CreateJobGetIndustryLoading = false;
        state.error = action.error.message;
        state.CreateJobGetIndustryData = [];
      })

      .addCase(GetJoinAs.pending, (state) => {
        state.getJoinAsStatus = "loading";
        state.getJoinAsLoading = true;
        state.getJoinAsData = [];
      })
      .addCase(GetJoinAs.fulfilled, (state, action) => {
        state.getJoinAsStatus = "succeeded";
        state.getJoinAsLoading = false;
        state.getJoinAsData = action.payload.Data;
      })
      .addCase(GetJoinAs.rejected, (state, action) => {
        state.getJoinAsStatus = "failed";
        state.getJoinAsLoading = false;
        state.error = action.error.message;
        state.getJoinAsData = [];
      })
      .addCase(GetEmailVerify.pending, (state) => {
        state.getEmailVerifyStatus = "loading";
        state.getEmailVerifyLoading = true;
        state.getEmailVerifyData = {};
      })
      .addCase(GetEmailVerify.fulfilled, (state, action) => {
        state.getEmailVerifyStatus = "succeeded";
        state.getEmailVerifyLoading = false;
        state.getEmailVerifyData = action.payload.Data;
      })
      .addCase(GetEmailVerify.rejected, (state, action) => {
        state.getEmailVerifyStatus = "failed";
        state.getEmailVerifyLoading = false;
        state.error = action.error.message;
        state.getEmailVerifyData = {};
      })
      //========================GetEducation====================//
      .addCase(GetEducation.pending, (state) => {
        state.getEducationStatus = "loading";
        state.getEducationLoading = true;
        state.getEducationData = [];
      })
      .addCase(GetEducation.fulfilled, (state, action) => {
        state.getEducationStatus = "succeeded";
        state.getEducationLoading = false;
        state.getEducationData = action.payload.Data;
      })
      .addCase(GetEducation.rejected, (state, action) => {
        state.getEducationStatus = "failed";
        state.getEducationLoading = false;
        state.error = action.error.message;
        state.getEducationData = [];
      })
      //========================GetExperience====================//
      .addCase(GetExperience.pending, (state) => {
        state.getExperienceStatus = "loading";
        state.getExperienceLoading = true;
        state.getExperienceData = [];
      })
      .addCase(GetExperience.fulfilled, (state, action) => {
        state.getExperienceStatus = "succeeded";
        state.getExperienceLoading = false;
        state.getExperienceData = action.payload.Data;
      })
      .addCase(GetExperience.rejected, (state, action) => {
        state.getExperienceStatus = "failed";
        state.getExperienceLoading = false;
        state.error = action.error.message;
        state.getExperienceData = [];
      })
      //========================GetMyAccount====================//
      .addCase(GetMyAccount.pending, (state) => {
        state.getMyAccountStatus = "loading";
        state.getMyAccountLoading = true;
        state.getMyAccountData = {};
        state.getExperienceUserData = [];
        state.getSkillByUserData = [];
        state.getEducationUserData = [];
        state.getUserLanguageData = [];
        state.getIndustryByUserData = [];
        state.getHeadshotData = [];
        state.getPhotosData = [];
        state.getVideosData = [];
        state.getArthographyData = [];
         state.getIntershipData = [];
          state.getApprenticeshipData = [];
        state.getMyAccountProjectData = [];
        state.getMyAccountSocialsData = [];
      })
      .addCase(GetMyAccount.fulfilled, (state, action) => {
        state.getMyAccountStatus = "succeeded";
        state.getMyAccountLoading = false;
        state.getMyAccountData = action.payload.Data;
        state.getExperienceUserData = action.payload.Data.Experience;
        state.getSkillByUserData = action.payload.Data.Skills;
        state.getEducationUserData = action.payload.Data.Education;
        state.getUserLanguageData = action.payload.Data.Language;
        state.getIndustryByUserData = action.payload.Data.Industry;
        state.getHeadshotData = action.payload.Data.Headshots;
        state.getPhotosData = action.payload.Data.Photos;
        state.getVideosData = action.payload.Data.Videos;
        state.getArthographyData = action.payload.Data.Artography;
        state.getIntershipData = action.payload.Data.Internship;
        state.getApprenticeshipData = action.payload.Data.Apprenticeship;
        state.getMyAccountProjectData = action.payload.Data.ProjectType;
        state.getMyAccountSocialsData = action.payload.Data.Socials;
      })
      .addCase(GetMyAccount.rejected, (state, action) => {
        state.getMyAccountStatus = "failed";
        state.getMyAccountLoading = false;
        state.error = action.error.message;
        state.getMyAccountData = {};
        state.getExperienceUserData = [];
        state.getSkillByUserData = [];
        state.getEducationUserData = [];
        state.getUserLanguageData = [];
        state.getIndustryByUserData = [];
        state.getHeadshotData = [];
        state.getPhotosData = [];
        state.getVideosData = [];
        state.getArthographyData = [];
        state.getIntershipData = [];
        state.getApprenticeshipData = [];
        state.getMyAccountProjectData = [];
        state.getMyAccountSocialsData = [];
      })
      //========================GetMyAccount====================//
      .addCase(GetUserLanguage.pending, (state) => {
        state.getUserLanguageStatus = "loading";
        state.getUserLanguageLoading = true;
        state.getUserLanguageData = [];
      })
      .addCase(GetUserLanguage.fulfilled, (state, action) => {
        state.getUserLanguageStatus = "succeeded";
        state.getUserLanguageLoading = false;
        state.getUserLanguageData = action.payload.Data;
      })
      .addCase(GetUserLanguage.rejected, (state, action) => {
        state.getUserLanguageStatus = "failed";
        state.getUserLanguageLoading = false;
        state.error = action.error.message;
        state.getUserLanguageData = [];
      })
      //========================GetLookingFor====================//
      .addCase(GetLookingFor.pending, (state) => {
        state.getLookingForStatus = "loading";
        state.getLookingForLoading = true;
        state.getLookingForData = [];
      })
      .addCase(GetLookingFor.fulfilled, (state, action) => {
        state.getLookingForStatus = "succeeded";
        state.getLookingForLoading = false;
        state.getLookingForData = action.payload.Data;
      })
      .addCase(GetLookingFor.rejected, (state, action) => {
        state.getLookingForStatus = "failed";
        state.getLookingForLoading = false;
        state.error = action.error.message;
        state.getLookingForData = [];
      })

      //========================SavedPOST/GetReport====================//
      .addCase(GETReport.pending, (state) => {
        state.GETReportStatus = "loading";
        state.GETReportLoading = true;
        state.GETReportData = [];
      })
      .addCase(GETReport.fulfilled, (state, action) => {
        state.GETReportStatus = "succeeded";
        state.GETReportLoading = false;
        state.GETReportData = action.payload.Data;
      })
      .addCase(GETReport.rejected, (state, action) => {
        state.GETReportStatus = "failed";
        state.GETReportLoading = false;
        state.error = action.error.message;
        state.GETReportData = [];
      })
      //================NETWORK/GetProjectComments==========

      .addCase(GetProjectComments.pending, (state) => {
        state.GETnetworkProjectStatus = "loading";
        state.GETnetworkProjectLoading = true;
        state.GETnetworkProjectData = [];
      })
      .addCase(GetProjectComments.fulfilled, (state, action) => {
        state.GETnetworkProjectStatus = "succeeded";
        state.GETnetworkProjectLoading = false;
        state.GETnetworkProjectData = action.payload.Data;
      })
      .addCase(GetProjectComments.rejected, (state, action) => {
        state.GETnetworkProjectStatus = "failed";
        state.GETnetworkProjectLoading = false;
        state.error = action.error.message;
        state.GETnetworkProjectData = [];
      })
      //================NETWORK/GetPOSTComments=============

      .addCase(GetPOSTComments.pending, (state) => {
        state.GETnetworkPostStatus = "loading";
        state.GETnetworkPostLoading = true;
        state.GETnetworkPostData = [];
      })
      .addCase(GetPOSTComments.fulfilled, (state, action) => {
        state.GETnetworkPostStatus = "succeeded";
        state.GETnetworkPostLoading = false;
        state.GETnetworkPostData = action.payload.Data;
      })
      .addCase(GetPOSTComments.rejected, (state, action) => {
        state.GETnetworkPostStatus = "failed";
        state.GETnetworkPostLoading = false;
        state.error = action.error.message;
        state.GETnetworkPostData = [];
      })

 


    //================NETWORK/GetProjectLikes==========

      .addCase(GetProjectLikes.pending, (state) => {
        state.GETnetworkProjectLikesStatus = "loading";
        state.GETnetworkProjectLikesLoading = true;
        state.GETnetworkProjectLikesData = [];
      })
      .addCase(GetProjectLikes.fulfilled, (state, action) => {
        state.GETnetworkProjectLikesStatus = "succeeded";
        state.GETnetworkProjectLikesLoading = false;
        state.GETnetworkProjectLikesData = action.payload.Data;
      })
      .addCase(GetProjectLikes.rejected, (state, action) => {
        state.GETnetworkProjectLikesStatus = "failed";
        state.GETnetworkProjectLikesLoading = false;
        state.error = action.error.message;
        state.GETnetworkProjectLikesData = [];
      })
      //================NETWORK/GetPostLikes=============

      .addCase(GetPostLikes.pending, (state) => {
        state.GETnetworkPostLikesStatus = "loading";
        state.GETnetworkPostLikesLoading = true;
        state.GETnetworkPostLikesData = [];
      })
      .addCase(GetPostLikes.fulfilled, (state, action) => {
        state.GETnetworkPostLikesStatus = "succeeded";
        state.GETnetworkPostLikesLoading = false;
        state.GETnetworkPostLikesData = action.payload.Data;
      })
      .addCase(GetPostLikes.rejected, (state, action) => {
        state.GETnetworkPostLikesStatus = "failed";
        state.GETnetworkPostLikesLoading = false;
        state.error = action.error.message;
        state.GETnetworkPostLikesData = [];
      })











      //============================CREATE/GET REACH LIMIT=================//
 

      .addCase(GETreachlimit.pending, (state) => {
        state.GETreachlimitStatus = "loading";
        state.GETreachlimitLoading = true;
        state.GETreachlimitData = [];
      })
      .addCase(GETreachlimit.fulfilled, (state, action) => {
        state.GETreachlimitStatus = "succeeded";
        state.GETreachlimitLoading = false;
        state.GETreachlimitData = action.payload.Data;
      })
      .addCase(GETreachlimit.rejected, (state, action) => {
        state.GETreachlimitStatus = "failed";
        state.GETreachlimitLoading = false;
        state.error = action.error.message;
        state.GETreachlimitData = [];
      })
      //========================GetByEducation====================//
      .addCase(GetByEducation.pending, (state) => {
        state.getEducationByStatus = "loading";
        state.getEducationByLoading = true;
        state.getEducationByData = {};
      })
      .addCase(GetByEducation.fulfilled, (state, action) => {
        state.getEducationByStatus = "succeeded";
        state.getEducationByLoading = false;
        state.getEducationByData = action.payload.Data;
      })
      .addCase(GetByEducation.rejected, (state, action) => {
        state.getEducationByStatus = "failed";
        state.getEducationByLoading = false;
        state.error = action.error.message;
        state.getEducationByData = {};
      })
      //========================GetByExperience====================//
      .addCase(GetByExperience.pending, (state) => {
        state.getExperienceByStatus = "loading";
        state.getExperienceByLoading = true;
        state.getExperienceByData = {};
      })
      .addCase(GetByExperience.fulfilled, (state, action) => {
        state.getExperienceByStatus = "succeeded";
        state.getExperienceByLoading = false;
        state.getExperienceByData = action.payload.Data;
      })
      .addCase(GetByExperience.rejected, (state, action) => {
        state.getExperienceByStatus = "failed";
        state.getExperienceByLoading = false;
        state.error = action.error.message;
        state.getExperienceByData = {};
      })

      //===================GetScreenCaption====================//
      .addCase(ScreenCaption.pending, (state) => {
        state.ScreenCaptionStatus = "loading";
        state.ScreenCaptionLoading = true;
        state.ScreenCaptionData = {};
      })
      .addCase(ScreenCaption.fulfilled, (state, action) => {
        state.ScreenCaptionStatus = "succeeded";
        state.ScreenCaptionLoading = false;
        state.ScreenCaptionData = action.payload.Data;
      })
      .addCase(ScreenCaption.rejected, (state, action) => {
        state.ScreenCaptionStatus = "failed";
        state.ScreenCaptionLoading = false;
        state.error = action.error.message;
        state.ScreenCaptionData = {};
      })
      //========================GetByExperience====================//
      .addCase(GetUserDevice.pending, (state) => {
        state.getUserDeviceStatus = "loading";
        state.getUserDeviceLoading = true;
        state.getUserDeviceData = [];
      })
      .addCase(GetUserDevice.fulfilled, (state, action) => {
        state.getUserDeviceStatus = "succeeded";
        state.getUserDeviceLoading = false;
        state.getUserDeviceData = action.payload.Data;
      })
      .addCase(GetUserDevice.rejected, (state, action) => {
        state.getUserDeviceStatus = "failed";
        state.getUserDeviceLoading = false;
        state.error = action.error.message;
        state.getUserDeviceData = [];
      })

      //========================GetOpportunities====================//
      .addCase(GetOpportunities.pending, (state) => {
        state.getOpportunitiesStatus = "loading";
        state.getOpportunitiesLoading = true;
        state.getOpportunitiesData = [];
        state.getOpportunitiesProfile = "";
      })
      .addCase(GetOpportunities.fulfilled, (state, action) => {
        state.getOpportunitiesStatus = "succeeded";
        state.getOpportunitiesLoading = false;
        state.getOpportunitiesData = action.payload.Data;
        state.getOpportunitiesProfile = action.payload.CompletedCount;
      })
      .addCase(GetOpportunities.rejected, (state, action) => {
        state.getOpportunitiesStatus = "failed";
        state.getOpportunitiesLoading = false;
        state.error = action.error.message;
        state.getOpportunitiesData = [];
        state.getOpportunitiesProfile = "";
      })

      //========================GetSearch====================//
      .addCase(GetSearch.pending, (state) => {
        state.getSearchStatus = "loading";
        state.getSearchLoading = true;
        state.getSearchAllData = [];
        state.getSearchGigData = [];
        state.getSearchProjectData = [];
        state.getSearchIntData = [];
        state.getSearchAptData = [];
        state.getSearchArtData = [];
        state.getSearchJobData = [];
      })
      .addCase(GetSearch.fulfilled, (state, action) => {
        state.getSearchStatus = "succeeded";
        state.getSearchLoading = false;
        state.getSearchAllData = action.payload.Data;
        state.getSearchGigData = action.payload.Data.Gigwork;
        state.getSearchProjectData = action.payload.Data.Project;
        state.getSearchIntData = action.payload.Data.Internship;
        state.getSearchAptData = action.payload.Data.Apprenticeship;
        state.getSearchArtData = action.payload.Data.Artist;
        state.getSearchJobData = action.payload.Data.JobCreate;
      })
      .addCase(GetSearch.rejected, (state, action) => {
        state.getSearchStatus = "failed";
        state.getSearchLoading = false;
        state.error = action.error.message;
        state.getSearchAllData = [];
        state.getSearchGigData = [];
        state.getSearchProjectData = [];
        state.getSearchIntData = [];
        state.getSearchAptData = [];
        state.getSearchArtData = [];
        state.getSearchJobData = [];
      })

      //========================Saved/GetSavedPosts====================//
      .addCase(GetSavedPosts.pending, (state) => {
        state.getSavedPostStatus = "loading";
        state.getSavedPostLoading = true;
        state.getSavedPostAllData = [];
        state.getSavedPostGigData = [];
        state.getSavedPostProjectData = [];
        state.getSavedPostIntData = [];
        state.getSavedPostAptData = [];
        state.getSavedPostArtData = [];
        state.getSavedPostJobData = [];
      })
      .addCase(GetSavedPosts.fulfilled, (state, action) => {
        state.getSavedPostStatus = "succeeded";
        state.getSavedPostLoading = false;
        state.getSavedPostAllData = action.payload.Data;
        state.getSavedPostGigData = action.payload.Data.Gigwork;
        state.getSavedPostProjectData = action.payload.Data.Project;
        state.getSavedPostIntData = action.payload.Data.Internship;
        state.getSavedPostAptData = action.payload.Data.Apprenticeship;
        state.getSavedPostArtData = action.payload.Data.Artist;
        state.getSavedPostJobData = action.payload.Data.JobCreate;
      })
      .addCase(GetSavedPosts.rejected, (state, action) => {
        state.getSavedPostStatus = "failed";
        state.getSavedPostLoading = false;
        state.error = action.error.message;
        state.getSavedPostAllData = [];
        state.getSavedPostGigData = [];
        state.getSavedPostProjectData = [];
        state.getSavedPostIntData = [];
        state.getSavedPostAptData = [];
        state.getSavedPostArtData = [];
        state.getSavedPostJobData = [];
      })

      //========================GetCollab====================//
      .addCase(GetCollab.pending, (state) => {
        state.getCollabStatus = "loading";
        state.getCollabLoading = true;
        state.getCollabData = [];
        state.getSuggestedCollabData = [];
        state.getCreatorsCollabData = [];
      })
      .addCase(GetCollab.fulfilled, (state, action) => {
        state.getCollabStatus = "succeeded";
        state.getCollabLoading = false;
        state.getCollabData = action.payload.Data;
        state.getSuggestedCollabData = action.payload.Data.SuggestCreator;
        state.getCreatorsCollabData = action.payload.Data.CreatorTowatch;
      })
      .addCase(GetCollab.rejected, (state, action) => {
        state.getCollabStatus = "failed";
        state.getCollabLoading = false;
        state.error = action.error.message;
        state.getCollabData = [];
        state.getSuggestedCollabData = [];
        state.getCreatorsCollabData = [];
      })
      //========================GetNetwork====================//
      .addCase(GetNetwork.pending, (state) => {
        state.getNetworkStatus = "loading";
        state.getNetworkLoading = true;
        state.getNetworkData = [];
      })
      .addCase(GetNetwork.fulfilled, (state, action) => {
        state.getNetworkStatus = "succeeded";
        state.getNetworkLoading = false;
        state.getNetworkData = action.payload.Data;
      })
      .addCase(GetNetwork.rejected, (state, action) => {
        state.getNetworkStatus = "failed";
        state.getNetworkLoading = false;
        state.error = action.error.message;
        state.getNetworkData = [];
      })
      //========================GetNotification====================//
      .addCase(GetNotification.pending, (state) => {
        state.getNotificationStatus = "loading";
        state.getNotificationLoading = true;
        state.getNotificationData = {};
      })
      .addCase(GetNotification.fulfilled, (state, action) => {
        state.getNotificationStatus = "succeeded";
        state.getNotificationLoading = false;
        state.getNotificationData = action.payload.Data;
      })
      .addCase(GetNotification.rejected, (state, action) => {
        state.getNotificationStatus = "failed";
        state.getNotificationLoading = false;
        state.error = action.error.message;
        state.getNotificationData = {};
      })

      //===================home/ GetHomeNotification===============//
      .addCase(GetHomeNotification.pending, (state) => {
        state.homeNotificationStatus = "loading";
        state.homeNotificationLoading = true;
        state.homeNotificationData = [];
      })
      .addCase(GetHomeNotification.fulfilled, (state, action) => {
        state.homeNotificationStatus = "succeeded";
        state.homeNotificationLoading = false;
        state.homeNotificationData = action.payload.Data;
      })
      .addCase(GetHomeNotification.rejected, (state, action) => {
        state.homeNotificationStatus = "failed";
        state.homeNotificationLoading = false;
        state.error = action.error.message;
        state.homeNotificationData = [];
      })
      //========================GetBookMark====================//
      .addCase(GetBookMark.pending, (state) => {
        state.getBookMarkStatus = "loading";
        state.getBookMarkLoading = true;
        state.getBookMarkData = [];
        state.getBookMarkArtiztData = [];
      })
      .addCase(GetBookMark.fulfilled, (state, action) => {
        state.getBookMarkStatus = "succeeded";
        state.getBookMarkLoading = false;
        state.getBookMarkArtiztData = action.payload.Data;
        //  const sorted = [...action.payload.Data].sort((a, b) =>
        //   (a.Name || "").toLowerCase().localeCompare((b.Name || "").toLowerCase())
        // );
        //   state.getBookMarkData = sorted;

        //   if (action.payload?.meta?.arg === "AR") {
        //     state.getBookMarkArtiztData = sorted;
        //   }
        //         console.log(state.getBookMarkData, "--state.getBookMarkData");
        //         console.log(state.getBookMarkArtiztData, "--state.getBookMarkArtiztData");
      })
      .addCase(GetBookMark.rejected, (state, action) => {
        state.getBookMarkStatus = "failed";
        state.getBookMarkLoading = false;
        state.error = action.error.message;
        state.getBookMarkData = [];
        state.getBookMarkArtiztData = [];
      })
      //========================GetGigWorkById====================//
      .addCase(GetGigWorkById.pending, (state) => {
        state.getGigWorkByIdStatus = "loading";
        state.getGigWorkByIdLoading = true;
        state.getGigWorkByIdData = {};
      })
      .addCase(GetGigWorkById.fulfilled, (state, action) => {
        state.getGigWorkByIdStatus = "succeeded";
        state.getGigWorkByIdLoading = false;
        state.getGigWorkByIdData = action.payload.Data;
        console.log(state.getGigWorkByIdData, "--state.getGigWorkByIdData");
      })
      .addCase(GetGigWorkById.rejected, (state, action) => {
        state.getGigWorkByIdStatus = "failed";
        state.getGigWorkByIdLoading = false;
        state.error = action.error.message;
        state.getGigWorkByIdData = {};
      })

      //========GetInterview==========================================
      .addCase(GetInterview.pending, (state) => {
        state.GetInterviewStatus = "loading";
        state.GetInterviewLoading = true;
        state.GetInterviewData = [];
      })
      .addCase(GetInterview.fulfilled, (state, action) => {
        state.GetInterviewStatus = "succeeded";
        state.GetInterviewLoading = false;
        state.GetInterviewData = action.payload.Data;
        console.log(state.GetInterviewData, "--state.GetInterviewData");
      })
      .addCase(GetInterview.rejected, (state, action) => {
        state.GetInterviewStatus = "failed";
        state.GetInterviewLoading = false;
        state.error = action.error.message;
        state.GetInterviewData = [];
      })

      //========GetSimilarJobs==========================================
      .addCase(GetSimilarJobs.pending, (state) => {
        state.GetSimilarJobsStatus = "loading";
        state.GetSimilarJobsLoading = true;
        state.GetSimilarJobsData = [];
      })
      .addCase(GetSimilarJobs.fulfilled, (state, action) => {
        state.GetSimilarJobsStatus = "succeeded";
        state.GetSimilarJobsLoading = false;
        state.GetSimilarJobsData = action.payload.Data;
        console.log(state.GetSimilarJobsData, "--state.GetSimilarJobsData");
      })
      .addCase(GetSimilarJobs.rejected, (state, action) => {
        state.GetSimilarJobsStatus = "failed";
        state.GetSimilarJobsLoading = false;
        state.error = action.error.message;
        state.GetSimilarJobsData = [];
      })
      //========================GetApprenticeshipById====================//
      .addCase(GetApprenticeshipById.pending, (state) => {
        state.getApprenticeshipByIdStatus = "loading";
        state.getApprenticeshipByIdLoading = true;
        state.getApprenticeshipByIdData = {};
      })
      .addCase(GetApprenticeshipById.fulfilled, (state, action) => {
        state.getApprenticeshipByIdStatus = "succeeded";
        state.getApprenticeshipByIdLoading = false;
        state.getApprenticeshipByIdData = action.payload.Data;
      })
      .addCase(GetApprenticeshipById.rejected, (state, action) => {
        state.getApprenticeshipByIdStatus = "failed";
        state.getApprenticeshipByIdLoading = false;
        state.error = action.error.message;
        state.getApprenticeshipByIdData = {};
      })
      //========================GetInternshipById====================//
      .addCase(GetInternshipById.pending, (state) => {
        state.getInternshipByIdStatus = "loading";
        state.getInternshipByIdLoading = true;
        state.getInternshipByIdData = {};
      })
      .addCase(GetInternshipById.fulfilled, (state, action) => {
        state.getInternshipByIdStatus = "succeeded";
        state.getInternshipByIdLoading = false;
        state.getInternshipByIdData = action.payload.Data;
      })
      .addCase(GetInternshipById.rejected, (state, action) => {
        state.getInternshipByIdStatus = "failed";
        state.getInternshipByIdLoading = false;
        state.error = action.error.message;
        state.getInternshipByIdData = {};
      })
      //========================GetInternshipById====================//
      .addCase(GetProjectById.pending, (state) => {
        state.getProjectByIdStatus = "loading";
        state.getProjectByIdLoading = true;
        state.getProjectByIdData = {};
      })
      .addCase(GetProjectById.fulfilled, (state, action) => {
        state.getProjectByIdStatus = "succeeded";
        state.getProjectByIdLoading = false;
        state.getProjectByIdData = action.payload.Data;
      })
      .addCase(GetProjectById.rejected, (state, action) => {
        state.getProjectByIdStatus = "failed";
        state.getProjectByIdLoading = false;
        state.error = action.error.message;
        state.getProjectByIdData = {};
      })
      //========================GetBlockedUser====================//
      .addCase(GetBlockedUser.pending, (state) => {
        state.getBlockedUserStatus = "loading";
        state.getBlockedUserLoading = true;
        state.getBlockedUserData = {};
      })
      .addCase(GetBlockedUser.fulfilled, (state, action) => {
        state.getBlockedUserStatus = "succeeded";
        state.getBlockedUserLoading = false;
        state.getBlockedUserData = action.payload.Data;
      })
      .addCase(GetBlockedUser.rejected, (state, action) => {
        state.getBlockedUserStatus = "failed";
        state.getBlockedUserLoading = false;
        state.error = action.error.message;
        state.getBlockedUserData = {};
      })
      //======================================GETHIRED
      .addCase(GetHired.pending, (state) => {
        state.getHiredStatus = "loading";
        state.getHiredLoading = true;
        state.getHiredGigData = [];
        state.getHiredIntData = [];
        state.getHiredAptData = [];
        state.getHiredAllData = [];
        state.getHiredJobsData = [];
        state.getHiredStoppedData = [];
        state.getHiredDraftData = [];
        state.getHiredClosedData = [];
        state.getHiredPausedData = [];
      })
      .addCase(GetHired.fulfilled, (state, action) => {
        state.getHiredStatus = "succeeded";
        state.getHiredLoading = false;
        state.getHiredGigData = action.payload.Data.Gigwork;
        state.getHiredIntData = action.payload.Data.Internship;
        state.getHiredAptData = action.payload.Data.Apprenticeship;
        state.getHiredAllData = action.payload.Data;
        state.getHiredJobsData = action.payload.Data.JobCreate;
        state.getHiredStoppedData = action.payload.Data.Stopped;
        state.getHiredDraftData = action.payload.Data.Draft;
        state.getHiredClosedData = action.payload.Data.Closed;
        state.getHiredPausedData = action.payload.Data.Paused;
      })
      .addCase(GetHired.rejected, (state, action) => {
        state.getHiredStatus = "failed";
        state.getHiredLoading = false;
        state.error = action.error.message;
        state.getHiredGigData = [];
        state.getHiredIntData = [];
        state.getHiredAptData = [];
        state.getHiredAllData = [];
        state.getHiredJobsData = [];
        state.getHiredStoppedData = [];
        state.getHiredDraftData = [];
        state.getHiredClosedData = [];
        state.getHiredPausedData = [];
      })

      //=====================Getslice for GetHireddashboard===========
      .addCase(GetHireddashboard.pending, (state) => {
        state.getdasboardStatus = "loading";
        state.getdasboardLoading = true;
        state.gtDashboardData = [];
      })
      .addCase(GetHireddashboard.fulfilled, (state, action) => {
        state.getdasboardStatus = "succeeded";
        state.getdasboardLoading = false;
        state.gtDashboardData = action.payload.Data;
      })
      .addCase(GetHireddashboard.rejected, (state, action) => {
        state.getdasboardStatus = "failed";
        state.getdasboardLoading = false;
        state.error = action.error.message;
        state.gtDashboardData = [];
      })
      //======================================GETAPPLIED
      .addCase(GetApplied.pending, (state) => {
        state.getAppliedStatus = "loading";
        state.getAppliedLoading = true;
        state.getAppliedGigData = [];
        state.getAppliedIntData = [];
        state.getAppliedAptData = [];
      })
      .addCase(GetApplied.fulfilled, (state, action) => {
        state.getAppliedStatus = "succeeded";
        state.getAppliedLoading = false;
        state.getAppliedGigData = action.payload.Data.Gigwork;
        state.getAppliedIntData = action.payload.Data.Internship;
        state.getAppliedAptData = action.payload.Data.Apprenticeship;
      })
      .addCase(GetApplied.rejected, (state, action) => {
        state.getAppliedStatus = "failed";
        state.getAppliedLoading = false;
        state.error = action.error.message;
        state.getAppliedGigData = [];
        state.getAppliedIntData = [];
        state.getAppliedAptData = [];
      })
      //========================GetBookMark====================//
      .addCase(GetAppliedArtist.pending, (state) => {
        state.getAppliedArtistStatus = "loading";
        state.getAppliedArtistLoading = true;
        state.getAppliedArtistData = [];
      })
      .addCase(GetAppliedArtist.fulfilled, (state, action) => {
        state.getAppliedArtistStatus = "succeeded";
        state.getAppliedArtistLoading = false;
        state.getAppliedArtistData = action.payload.Data;
      })
      .addCase(GetAppliedArtist.rejected, (state, action) => {
        state.getAppliedArtistStatus = "failed";
        state.getAppliedArtistLoading = false;
        state.error = action.error.message;
        state.getAppliedArtistData = [];
      })
      //========================PersonalChatList====================//
      .addCase(PersonalChatList.pending, (state) => {
        state.getPersonalChatListStatus = "loading";
        state.getPersonalChatListLoading = true;
        state.getPersonalChatListData = [];
      })
      .addCase(PersonalChatList.fulfilled, (state, action) => {
        state.getPersonalChatListStatus = "succeeded";
        state.getPersonalChatListLoading = false;
        state.getPersonalChatListData = action.payload.Data;
      })
      .addCase(PersonalChatList.rejected, (state, action) => {
        state.getPersonalChatListStatus = "failed";
        state.getPersonalChatListLoading = false;
        state.error = action.error.message;
        state.getPersonalChatListData = [];
      })
      //========================PersonalChatMessage====================//
      .addCase(PersonalChatMessage.pending, (state) => {
        state.getPersonalChatMessageStatus = "loading";
        state.getPersonalChatMessageLoading = true;
        state.getPersonalChatMessageData = [];
      })
      .addCase(PersonalChatMessage.fulfilled, (state, action) => {
        state.getPersonalChatMessageStatus = "succeeded";
        state.getPersonalChatMessageLoading = false;
        state.getPersonalChatMessageData = action.payload.Data;
      })
      .addCase(PersonalChatMessage.rejected, (state, action) => {
        state.getPersonalChatMessageStatus = "failed";
        state.getPersonalChatMessageLoading = false;
        state.error = action.error.message;
        state.getPersonalChatMessageData = [];
      })
      //========================GroupChatGet====================//
      .addCase(GroupChatGet.pending, (state) => {
        state.getGroupChatStatus = "loading";
        state.getGroupChatLoading = true;
        state.getGroupChatData = [];
      })
      .addCase(GroupChatGet.fulfilled, (state, action) => {
        state.getGroupChatStatus = "succeeded";
        state.getGroupChatLoading = false;
        state.getGroupChatData = action.payload.Data;
      })
      .addCase(GroupChatGet.rejected, (state, action) => {
        state.getGroupChatStatus = "failed";
        state.getGroupChatLoading = false;
        state.error = action.error.message;
        state.getGroupChatData = [];
      })
      //========================GroupChatMessage====================//
      .addCase(GroupChatMessage.pending, (state) => {
        state.getGroupChatMessageStatus = "loading";
        state.getGroupChatMessageLoading = true;
        state.getGroupChatMessageData = [];
      })
      .addCase(GroupChatMessage.fulfilled, (state, action) => {
        state.getGroupChatMessageStatus = "succeeded";
        state.getGroupChatMessageLoading = false;
        state.getGroupChatMessageData = action.payload.Data;
      })
      .addCase(GroupChatMessage.rejected, (state, action) => {
        state.getGroupChatMessageStatus = "failed";
        state.getGroupChatMessageLoading = false;
        state.error = action.error.message;
        state.getGroupChatMessageData = [];
      })
      //========================GroupChatGetBYID====================//
      .addCase(GroupChatGetBYID.pending, (state) => {
        state.getGroupStatus = "loading";
        state.getGroupLoading = true;
        state.getGroupData = {};
      })
      .addCase(GroupChatGetBYID.fulfilled, (state, action) => {
        state.getGroupStatus = "succeeded";
        state.getGroupLoading = false;
        state.getGroupData = action.payload.Data;
      })
      .addCase(GroupChatGetBYID.rejected, (state, action) => {
        state.getGroupStatus = "failed";
        state.getGroupLoading = false;
        state.error = action.error.message;
        state.getGroupData = {};
      })
      //========================GroupMember====================//
      .addCase(GroupMember.pending, (state) => {
        state.getGroupMemberStatus = "loading";
        state.getGroupMemberLoading = true;
        state.getGroupMemberData = [];
      })
      .addCase(GroupMember.fulfilled, (state, action) => {
        state.getGroupMemberStatus = "succeeded";
        state.getGroupMemberLoading = false;
        state.getGroupMemberData = action.payload.Data;
      })
      .addCase(GroupMember.rejected, (state, action) => {
        state.getGroupMemberStatus = "failed";
        state.getGroupMemberLoading = false;
        state.error = action.error.message;
        state.getGroupMemberData = [];
      })
      //========================ProjectType====================//
      .addCase(GetProjectType.pending, (state) => {
        state.getProjectTypeStatus = "loading";
        state.getProjectTypeLoading = true;
        state.getProjectTypeData = [];
      })
      .addCase(GetProjectType.fulfilled, (state, action) => {
        state.getProjectTypeStatus = "succeeded";
        state.getProjectTypeLoading = false;
        state.getProjectTypeData = action.payload.Data;
      })
      .addCase(GetProjectType.rejected, (state, action) => {
        state.getProjectTypeStatus = "failed";
        state.getProjectTypeLoading = false;
        state.error = action.error.message;
        state.getProjectTypeData = [];
      })
      //========================GetRoles====================//
      .addCase(GetRoles.pending, (state) => {
        state.getRolesStatus = "loading";
        state.getRolesLoading = true;
        state.getRolesData = [];
      })
      .addCase(GetRoles.fulfilled, (state, action) => {
        state.getRolesStatus = "succeeded";
        state.getRolesLoading = false;
        state.getRolesData = action.payload.Data;
      })
      .addCase(GetRoles.rejected, (state, action) => {
        state.getRolesStatus = "failed";
        state.getRolesLoading = false;
        state.error = action.error.message;
        state.getRolesData = [];
      })
      //========================GetCollaborator====================//
      .addCase(GetCollaborator.pending, (state) => {
        state.getCollaboratorStatus = "loading";
        state.getCollaboratorLoading = true;
        state.getCollaboratorData = [];
      })
      .addCase(GetCollaborator.fulfilled, (state, action) => {
        state.getCollaboratorStatus = "succeeded";
        state.getCollaboratorLoading = false;
        state.getCollaboratorData = action.payload.Data;
      })
      .addCase(GetCollaborator.rejected, (state, action) => {
        state.getCollaboratorStatus = "failed";
        state.getCollaboratorLoading = false;
        state.error = action.error.message;
        state.getCollaboratorData = [];
      })
      //========================ProjectType====================//
      .addCase(ProjectList.pending, (state) => {
        state.getProjectListStatus = "loading";
        state.getProjectListLoading = true;
        state.getProjectListData = [];
      })
      .addCase(ProjectList.fulfilled, (state, action) => {
        state.getProjectListStatus = "succeeded";
        state.getProjectListLoading = false;
        state.getProjectListData = action.payload.Data;
      })
      .addCase(ProjectList.rejected, (state, action) => {
        state.getProjectListStatus = "failed";
        state.getProjectListLoading = false;
        state.error = action.error.message;
        state.getProjectListData = [];
      })
      //========================ProjectType====================//
      .addCase(GetProject.pending, (state) => {
        state.getGetProjectStatus = "loading";
        state.getGetProjectLoading = true;
        state.getGetProjectData = [];
      })
      .addCase(GetProject.fulfilled, (state, action) => {
        state.getGetProjectStatus = "succeeded";
        state.getGetProjectLoading = false;
        state.getGetProjectData = action.payload.Data;
        state.getGetProjectCollabData = action.payload.Data.collaborators;
        state.getGetProjectEndoresementData = action.payload.Data.endorsements;
      })
      .addCase(GetProject.rejected, (state, action) => {
        state.getGetProjectStatus = "failed";
        state.getGetProjectLoading = false;
        state.error = action.error.message;
        state.getGetProjectData = [];
      })
      //========================GetCollaborator====================//
      .addCase(GetUnionAssociation.pending, (state) => {
        state.getUnionAssociationStatus = "loading";
        state.getUnionAssociationLoading = true;
        state.getUnionAssociationData = [];
      })
      .addCase(GetUnionAssociation.fulfilled, (state, action) => {
        state.getUnionAssociationStatus = "succeeded";
        state.getUnionAssociationLoading = false;
        state.getUnionAssociationData = action.payload.Data;
      })
      .addCase(GetUnionAssociation.rejected, (state, action) => {
        state.getUnionAssociationStatus = "failed";
        state.getUnionAssociationLoading = false;
        state.error = action.error.message;
        state.getUnionAssociationData = [];
      })
      .addCase(toolsSoftwareGet.pending, (state) => {
        state.gettoolsSoftwareStatus = "loading";
        state.gettoolsSoftwareLoading = true;
        state.gettoolsSoftwareData = [];
      })
      .addCase(toolsSoftwareGet.fulfilled, (state, action) => {
        state.gettoolsSoftwareStatus = "succeeded";
        state.gettoolsSoftwareLoading = false;
        state.gettoolsSoftwareData = action.payload.Data;
      })
      .addCase(toolsSoftwareGet.rejected, (state, action) => {
        state.gettoolsSoftwareStatus = "failed";
        state.gettoolsSoftwareLoading = false;
        state.error = action.error.message;
        state.gettoolsSoftwareData = [];
      })

      //CREATE_ JOB_GETBENEFITS=============

      .addCase(CreateJobGetBenefits.pending, (state) => {
        state.getbenefitsStatus = "loading";
        state.getbenefitsLoading = true;
        state.getbenefitsData = [];
      })
      .addCase(CreateJobGetBenefits.fulfilled, (state, action) => {
        state.getbenefitsStatus = "succeeded";
        state.getbenefitsLoading = false;
        state.getbenefitsData = action.payload.Data;
      })
      .addCase(CreateJobGetBenefits.rejected, (state, action) => {
        state.getbenefitsStatus = "failed";
        state.getbenefitsLoading = false;
        state.error = action.error.message;
        state.getbenefitsData = [];
      })

      //CREATE_ JOB_GETBENEFITS=============

      .addCase(GetJobByID.pending, (state) => {
        state.getJobIDStatus = "loading";
        state.getJobIDLoading = true;
        state.getJobIDData = {};
      })
      .addCase(GetJobByID.fulfilled, (state, action) => {
        state.getJobIDStatus = "succeeded";
        state.getJobIDLoading = false;
        state.getJobIDData = action.payload.Data;
      })
      .addCase(GetJobByID.rejected, (state, action) => {
        state.getJobIDStatus = "failed";
        state.getJobIDLoading = false;
        state.error = action.error.message;
        state.getJobIDData = {};
      })

      //========================GetDashboardData====================//
      .addCase(GetDashboardData.pending, (state) => {
        state.getDashboardStatus = "loading";
        state.getDashboardLoading = true;
        state.getDashboardData = {};
        state.getDashboardUIData = [];
      })
      .addCase(GetDashboardData.fulfilled, (state, action) => {
        state.getDashboardStatus = "succeeded";
        state.getDashboardLoading = false;
        state.getDashboardData = action.payload.Data;
        state.getDashboardUIData = action.payload.Data.UpcomingInterviews;
      })
      .addCase(GetDashboardData.rejected, (state, action) => {
        state.getDashboardStatus = "failed";
        state.getDashboardLoading = false;
        state.error = action.error.message;
        state.getDashboardData = {};
        state.getDashboardUIData = [];
      })


    


 //========================MYPROFILE / GETfollowusers====================//
      .addCase(GetFollowingUsers.pending, (state) => {
        state.getFollowUsersStatus = "loading";
        state.getFollowUsersLoading = true;
        state.getFollowUsersData = [];
      })
      .addCase(GetFollowingUsers.fulfilled, (state, action) => {
        state.getFollowUsersStatus = "succeeded";
        state.getFollowUsersLoading = false;
        state.getFollowUsersData = action.payload.Data;
      })
      .addCase(GetFollowingUsers.rejected, (state, action) => {
        state.getFollowUsersStatus = "failed";
        state.getFollowUsersLoading = false;
        state.error = action.error.message;
        state.getFollowUsersData = [];
      })

      //========================ApplicationHistoryGet====================//
      .addCase(ApplicationHistoryGet.pending, (state) => {
        state.getApplicationHistoryStatus = "loading";
        state.getApplicationHistoryLoading = true;
        state.getApplicationHistoryData = [];
      })
      .addCase(ApplicationHistoryGet.fulfilled, (state, action) => {
        state.getApplicationHistoryStatus = "succeeded";
        state.getApplicationHistoryLoading = false;
        state.getApplicationHistoryData = action.payload.Data.ALL;
      })
      .addCase(ApplicationHistoryGet.rejected, (state, action) => {
        state.getApplicationHistoryStatus = "failed";
        state.getApplicationHistoryLoading = false;
        state.getApperror = action.error.message;
        state.getApplicationHistoryData = [];
      })

      //========================ApplicationHistoryGet====================//
      .addCase(GetAppliedUser.pending, (state) => {
        state.getAppliedUserStatus = "loading";
        state.getAppliedUserDetailsLoading = true;
        state.getAppliedUserCreaData = [];
        state.getAppliedUserApplicantsData = [];
      })
      .addCase(GetAppliedUser.fulfilled, (state, action) => {
        state.getAppliedUserStatus = "succeeded";
        state.getAppliedUserDetailsLoading = false;
        state.getAppliedUserCreaData =action.payload.Data.CreaChoice;
        state.getAppliedUserApplicantsData =action.payload.Data.Applicants;
      })
      .addCase(GetAppliedUser.rejected, (state, action) => {
        state.getAppliedUserStatus = "failed";
        state.getAppliedUserDetailsLoading = false;
        state.error = action.error.message;
        state.getAppliedUserCreaData = [];
        state.getAppliedUserApplicantsData = [];
      })
      //========================ApplicationHistoryGet====================//
      .addCase(GetNotes.pending, (state) => {
        state.getNotesStatus = "loading";
        state.getNotesLoading = true;
        state.getNotesData = [];
      })
      .addCase(GetNotes.fulfilled, (state, action) => {
        state.getNotesStatus = "succeeded";
        state.getNotesLoading = false;
        state.getNotesData =action.payload.Data;
      })
      .addCase(GetNotes.rejected, (state, action) => {
        state.getNotesStatus = "failed";
        state.getNotesLoading = false;
        state.error = action.error.message;
        state.getNotesData = [];
      })
      //========================ApplicationHistoryGet====================//
      .addCase(PlanGet.pending, (state) => {
        state.getPlanGetStatus = "loading";
        state.getPlanGetLoading = true;
        state.getPlanGetData = [];
      })
      .addCase(PlanGet.fulfilled, (state, action) => {
        state.getPlanGetStatus = "succeeded";
        state.getPlanGetLoading = false;
        state.getPlanGetData =action.payload.Data;
      })
      .addCase(PlanGet.rejected, (state, action) => {
        state.getPlanGetStatus = "failed";
        state.getPlanGetLoading = false;
        state.error = action.error.message;
        state.getPlanGetData = [];
      })
        //========================GetSubscriptionDetails====================//
      .addCase(GetSubscriptionDetails.pending, (state) => {
        state.getSubscriptionDetailsStatus = "loading";
        state.getSubscriptionDetailsLoading = true;
           state.getSubscriptionDetailsData = [];
        state.getSubscriptionDetailsBillingData = [];
      })
      .addCase(GetSubscriptionDetails.fulfilled, (state, action) => {
        state.getSubscriptionDetailsStatus = "succeeded";
        state.getSubscriptionDetailsLoading = false;
        state.getSubscriptionDetailsData =action.payload.Data;
        state.getSubscriptionDetailsBillingData =action.payload.Data.map((p)=>p.billinghistory);
      })
      .addCase(GetSubscriptionDetails.rejected, (state, action) => {
        state.getSubscriptionDetailsStatus = "failed";
        state.getSubscriptionDetailsLoading = false;
        state.error = action.error.message;
        state.getSubscriptionDetailsData = [];
        state.getSubscriptionDetailsBillingData = [];
      });
  },
});
export const { sortBookMarkArtizts } = getSlice.actions;

export default getSlice.reducer;
